import { Link } from 'react-router-dom';
import { useFontSize, type FontSize } from '../lib/fontSize';
import { usePlan } from '../lib/plan';

const OPTIONS: { value: FontSize; label: string; className: string }[] = [
  { value: 'md', label: 'Standard text size', className: 'text-[0.8rem]' },
  { value: 'lg', label: 'Large text size', className: 'text-[0.95rem]' },
  { value: 'xl', label: 'Extra large text size', className: 'text-[1.1rem]' },
];

export function SiteHeader() {
  const { size, setSize } = useFontSize();
  const plan = usePlan();
  return (
    <header className="print-hide border-b border-line/70">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3 sm:px-6">
        <Link
          to="/"
          className="font-serif text-xl font-semibold tracking-tight focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink"
        >
          Cookbook
        </Link>
        <div className="flex items-center gap-2.5">
        <Link
          to="/plan"
          className={`inline-flex h-11 items-center gap-1.5 rounded-full border px-3.5 font-sans text-[0.85rem] font-semibold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink ${
            plan.count ? 'border-freeze bg-freeze-tint text-freeze' : 'border-line bg-card text-ink-soft hover:text-ink'
          }`}
        >
          This week
          {plan.count > 0 && (
            <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-freeze px-1.5 font-sans text-[0.72rem] font-bold text-paper">
              {plan.count}
            </span>
          )}
        </Link>
        <div
          role="group"
          aria-label="Text size"
          className="flex items-center rounded-full border border-line bg-card"
        >
          {OPTIONS.map((o) => (
            <button
              key={o.value}
              type="button"
              aria-label={o.label}
              aria-pressed={size === o.value}
              onClick={() => setSize(o.value)}
              className={`flex h-11 w-11 items-center justify-center rounded-full font-sans font-semibold leading-none transition-colors focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-ink ${o.className} ${
                size === o.value ? 'bg-ink text-paper' : 'text-ink-soft hover:text-ink'
              }`}
            >
              A
            </button>
          ))}
        </div>
        </div>
      </div>
    </header>
  );
}
